import React from 'react';

import { TabLoader, TabConfig, addTab, removeAll } from 'wdna-components/lib/tabs';

import { hasOnePermission } from '../../../services/user/actions';

const Graphs: React.LazyExoticComponent<any> = React.lazy(() => import('../components/dashboard/Graphs'));

export default class Loader extends TabLoader {
  /* Override tab loader method */
  public loadTab = (tabId?: string | number): void => {
    // const access = hasOnePermission(['thralarms_ro', 'thralarms_rw']);
    const access: boolean = true;
    if (access) {
      window.store.dispatch(removeAll());

      const tabData: TabConfig = {
        id: String(tabId || window.getStr()),
        active: true,
        title: 'Sensors | Graphs',
        component: Graphs,
        props: {
          report: 'SENSOR_GRAPHS',
          title: 'Graphs',
        },
      };

      window.store.dispatch(addTab(tabData));
    }
  };
}
